
import { Component, Vue } from 'vue-property-decorator'
import { useCultureSubsidyStore } from '@/stores/cultureSubsidy'
import { BeneficiaryCumul } from '../types'

@Component({ name: 'BeneficiariesPanel' })
export default class extends Vue {
  store = useCultureSubsidyStore()
  search = ''
  capFilter = 'all'

  get cap(): number {
    return this.store.settings?.annualBeneficiaryCapping || 0
  }

  get filtered(): BeneficiaryCumul[] {
    return this.store.beneficiaries.filter(row => {
      if (this.search) {
        const q = this.search.toLowerCase()
        if (!`${row.firstName} ${row.lastName} ${row.email}`.toLowerCase().includes(q)) return false
      }
      if (this.capFilter === 'cap' && row.consumed < this.cap) return false
      if (this.capFilter === 'near' && (this.cap <= 0 || row.consumed / this.cap < 0.8)) return false
      return true
    })
  }

  percent(consumed: number): number {
    if (!this.cap) return 0
    return Math.min(100, Math.round((consumed / this.cap) * 100))
  }

  barColor(consumed: number): string {
    const ratio = this.cap ? consumed / this.cap : 0
    if (ratio >= 1) return '#C42B2B'
    if (ratio >= 0.8) return '#E6A23C'
    return '#1890FF'
  }
}
